
























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import OpenIncidentModal from "../OpenIncidentModal.vue";
import { ShipmentListItem } from "../../../model/component.model";
import { canShowIncidentButton } from "@/helpers/useIncidentButton";

@Component({
  components: {
    OpenIncidentModal
  }
})
export default class WineShipmentsManagementToolbar extends Vue {
  @Prop() selectedItems: ShipmentListItem[];
  @Prop() selectedTab: string;

  showOpenIncidentModal = false;

  selectedItemsCount() {
    return this.selectedItems.length;
  }

  openIncidentModal() {
    this.showOpenIncidentModal = true;
  }

  get showIncidentButton() {
    return (
      canShowIncidentButton(this.selectedTab, this.selectedItems) &&
      this.$store.getters["customer/claimConfig"].canOpenIncidents
    );
  }

  get isPrintWaybillButtonEnabled() {
    return (
      this.$store.getters["customer/config"].canPrintWaybill &&
      this.selectedItems.some(
        (shipment: ShipmentListItem) =>
          shipment.status === "CREATED" ||
          shipment.status === "DRAFT_WAYBILL" ||
          shipment.status === "INVOICED"
      )
    );
  }

  incidentOpened() {
    this.$notify.success(String(this.$t("incident_opened")));
    this.showOpenIncidentModal = false;
  }
}
